import { render, staticRenderFns } from "./SidepanelDropdown.vue?vue&type=template&id=b52fdb40&"
import script from "./SidepanelDropdown.vue?vue&type=script&lang=js&"
export * from "./SidepanelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SidepanelDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports